module.exports = __webpack_public_path__ + "img/raglan_tee.c7281004.jpg";